/* Generated by TinySVG. Do not edit directly. */
import type { TinyIconProps } from '../types.ts'

export function DrawerOpenRightIcon({
  size = 24,
  color = 'currentColor',
  strokeWidth,
  title,
  ...svgProps
}: TinyIconProps) {
  const resolvedStrokeWidth = strokeWidth ?? 1.75
  const scaledStrokeWidth = (percent: number) => {
    const numericStrokeWidth = typeof resolvedStrokeWidth === 'number' ? resolvedStrokeWidth : Number(resolvedStrokeWidth)
    return Number.isFinite(numericStrokeWidth) ? numericStrokeWidth * percent / 100 : resolvedStrokeWidth
  }
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      strokeWidth={resolvedStrokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
      data-icon="drawer-open-right"
      data-variant="outline"
      role={title ? 'img' : undefined}
      aria-hidden={title ? undefined : true}
      focusable="false"
      {...svgProps}
    >
      {title ? <title>{title}</title> : null}
          <path d="M2.5 6.5C2.5 5.395 3.395 4.5 4.5 4.5L19.5 4.5C20.605 4.5 21.5 5.395 21.5 6.5L21.5 17.5C21.5 18.605 20.605 19.5 19.5 19.5L4.5 19.5C3.395 19.5 2.5 18.605 2.5 17.5L2.5 6.5Z" data-tinysvg-shape="path" stroke={color} fill="none" data-stroke-tone="primary" />
          <path d="M12 10C12.008 9.774 12.036 9.557 12.11 9.343C12.167 9.18 12.245 9.025 12.342 8.882C12.437 8.74 12.551 8.611 12.679 8.498C13.043 8.178 13.516 8.001 14 8C14.667 7.999 15.333 7.999 16 8C16.267 8.001 16.532 8.053 16.778 8.157C16.884 8.202 16.909 8.218 17.009 8.273C17.155 8.365 17.292 8.463 17.414 8.586C17.788 8.959 17.999 9.472 18 10C18.002 11.379 18.042 12.759 17.995 14.137C17.973 14.359 17.93 14.572 17.843 14.778C17.776 14.937 17.688 15.086 17.583 15.222C17.206 15.71 16.616 15.999 16 16C15.333 16.001 14.667 16.001 14 16C13.733 15.999 13.468 15.947 13.222 15.843C13.116 15.798 13.091 15.782 12.991 15.727C12.845 15.635 12.708 15.537 12.586 15.414C12.212 15.041 12.001 14.528 12 14C11.999 12.667 12 11.333 12 10Z" data-tinysvg-shape="path" stroke="none" fill={color} data-fill-tone="primary" />
          <path d="M12 10C12 8.895 12.895 8 14 8L16 8C17.105 8 18 8.895 18 10L18 14C18 15.105 17.105 16 16 16L14 16C12.895 16 12 15.105 12 14L12 10Z" data-tinysvg-shape="path" stroke={color} fill="none" data-stroke-tone="primary" />
    </svg>
  )
}
